import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Avatar,
  Button,
  Stack,
  Paper,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ShareIcon from "@mui/icons-material/Share";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AddIcon from "@mui/icons-material/Add";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

import { fetchEarningActivities } from "../../apiservices/ApiService";

import PWAHeader from "../../common/PWAHeader";
import AppNavigation from "../../navigation/AppNavigation";


    const statementOnTap = {
        NavigationType: "3",
        FSN: "300",
        FAI: {
          url: "https://lifestyle.goqii.com/lifestyleinsights/a1JYSk91Ry9SYWNoTE8rNjNiUTA5UT09?callingFrom=player",
          title: "GOQii Life",
        },
      };
const GOQiiCashScreen = () => {
  const { handleNavigation } = AppNavigation();
  const [loading, setLoading] = useState(true);
  // const [earnCashEvents, setEarnCashEvents] = useState([]);
  const earnCashEvents=[
   
    {
      "activityName": "Doctor Call Completion",
      "cashPoints": "50",
      "cashPointsPaid": "100"
    },
    {
      "activityName": "Attended GOQii Pro class",
      "cashPoints": "25",
      "cashPointsPaid": "50"
    },
   
    {
      "activityName": "Attended GOQiiPlay Health Class",
      "cashPoints": "1",
      "cashPointsPaid": "5"
    }
  ];
  const [rewardData, setRewardData] = useState(null);
  const bodyParamter = "testing";

  useEffect(() => {
    const fetchEarning = async () => {
      try {
        setLoading(true);

        // Fetch API Response
        const response = await fetchEarningActivities({ bodyParamter });


          // setEarnCashEvents(response.earnCashEvents);
          setRewardData(response);

       
      } catch (err) {

      } finally {
        setLoading(false);
      }
    };

    fetchEarning();
  }, []);
  const handleBackButtonPress = () => {
    if (window.Android && window.Android.onBackPressed) {
      window.Android.onBackPressed();
    } else {
      console.log("Back button pressed: No Android interface available");
      window.history.back();
    }
  };
  return (
    <Box sx={{ maxWidth: 600, margin: "0 auto", backgroundColor: "rgba(255, 152, 0, 0.11)" }}>
      {/* Header */}
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
        }}
      >
        <ArrowBackIosIcon sx={{ cursor: "pointer" }} onClick={handleBackButtonPress} />
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
          GOQii Cash
        </Typography>
      </Box> */}

      <PWAHeader title={"Loyalty Rewards"}  />

      {/* Cash Balance Section */}
      <Paper
        elevation={3}
        sx={{
          margin: "16px",
          padding: "16px",
          borderRadius: "12px",
          background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2) 100%)",
          border: "1px solid #771615",
          textAlign: "center", // Center align content
        }}
      >
        <Stack direction="column" alignItems="center" spacing={1}>
          <Avatar
            src="https://appcdn.goqii.com/storeimg/41469_1733644344.webp"
            alt="GOQii Cash"
            sx={{ width: 50, height: 50 }}
          />
          <Typography variant="body1" color="#771615" fontWeight="bold">
            GOQii Cash Balance
          </Typography>
          <Typography variant="h6" fontWeight="bold" color="#771615">
            {rewardData?.totalRewardPoints || "0"}
          </Typography>
          <Typography
            variant="caption"
            color="error"
            sx={{ fontSize: "12px" }}
          >
            {rewardData?.expiringGC || "-"} Expires on{" "}
            {rewardData?.expiringGCColored || "-"}
          </Typography>
        </Stack>
        <Button
          onClick={()=>handleNavigation(statementOnTap)}
          variant="text"
          // onClick={() => handleNavigation({ NavigationType: "3", FSN: "300", FAI: {} })}
          // onClick={handleNavigation({ NavigationType: "3", FSN: "GOQiiCashStatement" })}
    sx={{
      border: "1px solid #771615",
      marginTop: "16px",
      color: "#771615",
      fontSize: "12px",
      '&:hover': {
        backgroundColor: '#681517',
        color: '#fff',
      }
    }}
  >
    View More
  </Button>
      </Paper>

    
      {/* Footer Options */}
      <Divider sx={{ marginY: 2 }} />
     
      {/* Earning Activities Table */}
      <Paper
        elevation={3}
        sx={{
          margin: "16px",
          padding: "16px",
          borderRadius: "12px",
          background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.11) 100%)",
          border: "1px solid #771615",
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: "#771615" }}>
          How to Earn GOQii Cash?
        </Typography>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer color="#771615" component={Paper} sx={{ borderRadius: "12px", boxShadow: "0px 1px 3px #771615" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#771615" }}>Activity Name</TableCell>
                  {/* <TableCell  align="center" sx={{ color: "#771615" }}>Elite & Fit</TableCell> */}
                  <TableCell align="center" sx={{ color: "#771615" }}>GOQii Cash Credited</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {earnCashEvents.length > 0 ? (
                  earnCashEvents.map((event, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ color: "#771615" }}>{event.activityName}</TableCell>
                      {/* <TableCell sx={{ color: "#771615" }} align="center">{event.cashPointsPaid}</TableCell> */}
                      <TableCell sx={{ color: "#771615" }} align="center">{event.cashPoints}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No activities available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
};

export default GOQiiCashScreen;